import type React from 'react';

import { Button } from '@change/ds-core-ui';
import { Radio, RadioGroup } from '@change/ds-forms';
import { CloseIcon } from '@change/ds-icons';

import { useI18n } from '@change-corgi/core/react/i18n';

import type { Props } from '../../shared/types';

import { ButtonContainer } from './components/ButtonContainer';
import { TextContainer } from './components/TextContainer';
import { useLayout } from './hooks/useLayout';

export const Layout: React.FC<Props> = (props) => {
	const { translate } = useI18n();
	const {
		data: { visible, ref, paymentTerm, showOneTimePaymentTerm, showYearlyPaymentTerm },
		actions: { onClickClose, onChange },
	} = useLayout();

	if (!visible) return null;

	const { slug } = props;
	const showPaymentTermSelector = showOneTimePaymentTerm || showYearlyPaymentTerm;

	return (
		<div
			ref={ref}
			className="bg-gradient-background-light-2 fixed bottom-0 left-0 z-4900 hidden w-full border p-6 md:block"
			data-testid="membership-bottom-banner"
			role="alert"
		>
			<div className="fixed right-5">
				<Button
					data-testid="close-icon"
					data-qa="membership-popup-close-button"
					onClick={onClickClose}
					aria-label="Close"
					variant="secondary-solid"
					size="small"
					iconOnly
					leadingIcon={<CloseIcon size="small" />}
				/>
			</div>
			<div className="mx-auto max-w-304 md:w-185 lg:w-240 xl:w-304">
				<div className="flex flex-wrap gap-8">
					<div className="flex flex-5">
						<TextContainer />
					</div>
					<div className="flex flex-3 flex-col">
						{showPaymentTermSelector && (
							<div className="pb-4" data-qa="payment-term-selector">
								<RadioGroup
									name="payment-terms-banner"
									label=""
									labelIsVisible={false}
									value={paymentTerm}
									onChange={onChange}
									orientation="horizontal"
									className="justify-evenly"
								>
									{showOneTimePaymentTerm && (
										<Radio value="one-time" data-testid="payment-terms-banner-one-time-radio">
											{translate('corgi.membership.payment_form.terms.one_time')}
										</Radio>
									)}
									<Radio value="monthly" data-testid="payment-terms-banner-monthly-radio">
										{translate('corgi.membership.payment_form.terms.monthly')}
									</Radio>
									{showYearlyPaymentTerm && (
										<Radio value="yearly" data-testid="payment-terms-banner-yearly-radio">
											{translate('corgi.membership.payment_form.terms.yearly')}
										</Radio>
									)}
								</RadioGroup>
							</div>
						)}
						<ButtonContainer onClick={onClickClose} slug={slug} />
					</div>
				</div>
			</div>
		</div>
	);
};
